import React from "react";
import ProjectCard from "../../components/ProjectCard/ProjectCard";
import { Fade } from "react-reveal";
import "./Competitive.css";
import { t } from "i18next";

function Projects(props) {
  const theme = props.theme;

  const projects = {
    data: [
      {
        id: "0",
        name: t(
          "sections.home.competitive-advantage.advantages.titles.distribution"
        ),
        url: "https://github.com/kevalvavaliya/Yog4Life",
        description: t(
          "sections.home.competitive-advantage.advantages.contents.distribution"
        ),
        languages: [
          {
            name: t(
              "sections.home.competitive-advantage.advantages.titles.distribution"
            ),
            iconifyClass: "mdi-truck",
          },
        ],
      },
      {
        id: "1",
        name: t("sections.home.competitive-advantage.advantages.titles.haccp"),
        url: "https://github.com/Bauddhik-Geeks/Bauddhik-Geeks.github.io",
        description: t(
          "sections.home.competitive-advantage.advantages.contents.haccp"
        ),
        languages: [
          {
            name: t(
              "sections.home.competitive-advantage.advantages.titles.haccp"
            ),
            iconifyClass: "mdi-leaf",
          },
        ],
      },
      {
        id: "2",
        name: t(
          "sections.home.competitive-advantage.advantages.titles.facilities"
        ),
        url: "https://github.com/harikanani/e-commerce-frontend",
        description: t(
          "sections.home.competitive-advantage.advantages.contents.facilities"
        ),
        languages: [
          {
            name: t(
              "sections.home.competitive-advantage.advantages.titles.facilities"
            ),
            iconifyClass: "mdi-globe",
          },
        ],
      },
    ],
  };

  return (
    <div className="projects-main">
      <div className="basic-projects">
        <Fade bottom duration={2000} distance="40px">
          <div className="projects-heading-div">
            <div className="projects-heading-text-div">
              <h1
                className="projects-heading-text"
                style={{ color: theme.text }}
              >
                {t("titles.competitive-advantages")}
              </h1>
              <p
                className="projects-header-detail-text subTitle"
                style={{ color: theme.secondaryText }}
              >
                {t("sections.home.competitive-advantage.sub-title")}
              </p>
            </div>
          </div>
        </Fade>
      </div>
      <div className="repo-cards-div-main">
        {projects.data.map((repo, index) => {
          return <ProjectCard repo={repo} theme={theme} key={index} />;
        })}
      </div>
    </div>
  );
}

export default Projects;
